import { useEffect, useCallback, useRef } from 'react';
import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { CTAButton } from '@tmsw/powerups.ui.buttons.cta-button';
import { focusSettingsToggler } from '../../services/focusSettingsToggler';
import { ReactComponent as PausedIcon } from './paused_icon.svg';
import './PauseGeneral.css';
import { usePauseConditions } from '../../hooks/usePauseConditions';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';
export interface PauseGeneralProps {
  tabBack: () => void;
}

export const PauseGeneral = ({ tabBack }: PauseGeneralProps) => {
  const { __t } = useTranslation('PAUSE_MENU');
  const setIsPauseEnabled = useStore(
    useCallback((state) => state.setIsPauseEnabled, [])
  );
  const pageTitle = useStore((state) => state.pageTitle);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);
  const page = useStore((state) => state.page);
  const { getPageKey } = usePageConfig();
  const pageKey = getPageKey(page);

  const originalPageTitleRef = useRef(pageTitle);

  useEffect(() => {
    setPageTitle(__t('pageTitle'));
    document.querySelector('.game-wrapper')?.classList.add('PAUSE_MENU');
    const originalPageTitle = originalPageTitleRef.current;
    return () => {
      document.querySelector('.game-wrapper')?.classList.remove('PAUSE_MENU');
      setPageTitle(originalPageTitle);
    };
  }, []);

  useEffect(() => {
    console.log('PauseGeneral mount', pageKey);
    setIsPauseEnabled(true);
    if (pageKey !== 'GAME_PLAY') {
      // focusSettingsToggler();
      // @ts-ignore
      document.activeElement?.blur();
      document.body.focus();
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <section
      role="dialog"
      aria-modal="true"
      className="pause-menu-dialog"
      style={{
        backgroundImage: `url(${__t('backgrounds.main', 'GENERAL')})`,
      }}
    >
      <div className="pause-menu-content">
        <div className="pause-icon-container">
          <PausedIcon className="pause-icon" />
          <h1 className="pauseH1" aria-label={__t('h1')} tabIndex={0}>
            {__t('h1')}
          </h1>
        </div>
        <div className="pause-btn-list">
          <CTAButton
            className="resume-btn"
            primary
            onClick={tabBack}
            intlKey={'buttons.resume'}
            parentNode={'GENERAL'}
          />
        </div>
      </div>
    </section>
  );
};
